<template>
  <div id="stepComponent">
    <ul class="process--ul">
      <li v-for="step in steps" :key="step.id" :class="liClass(step)">{{step.stepName}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'step-component',
  props: ['steps'],
  methods: {
    liClass: function(step) {
      if(step.visited) {
        return "visited"
      } else if(step.current) {
        return "current"
      }
      return ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  #stepComponent {
    font-family: 游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN",HGS明朝E,メイリオ,Meiryo,serif;
  }
  .current {
    background-color: #ae952f !important;
    color: #fff !important;
    position: relative;
    
    &::after {
      height: 0;
      width: 0;
      content: "";
      border: 25px solid transparent;
      border-left: 12px solid #ae952f;
      position: absolute;
      right: -37px;
      top: 50%;
      margin-top: -26px;
    }
   
  }
  .visited {
    background-color: #999 !important;
    color: #fff !important;
    position: relative;
    &::after {
      height: 0;
      width: 0;
      content: "";
      border: 26px solid transparent;
      border-left: 12px solid #999;
      position: absolute;
      right: -38px;
      top: 50%;
      margin-top: -26px;
      z-index: 10;
    }
  }
  .process--ul {
    list-style: none;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 80px;
    margin-bottom: 50px;
    padding-left: 0;
    @media (max-width: 767.98px) {
      width: 100%;
      padding-left: 0;
    }
    li {
      width: 16.666%;
      width: calc(100%/6);
      padding: 15px 23px;
      background-color: #f5f5f5;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.64;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: 1199.98px) {
        width: 33.333%;
        width: calc(100%/3);
        font-size: 12px;
      }
    }
    li:nth-of-type(3n) {
      &::after {
        
        @media (max-width: 1199.98px) {
          border: 0;
        }
      }
    }
  }
</style>
